import successSound from '../../../assets/sounds/confetti-pop-sound.mp3';
import correct from '../../../assets/sounds/correct.mp3';
import TADAM from '../../../assets/sounds/TADAM.mp3';
import duolingo from '../../../assets/sounds/duolingo.mp3';
import palmas from '../../../assets/sounds/palmas.mp3';
import axios, { AxiosRequestConfig } from 'axios';
import { getSessionCredentials, verifyRoutePermissions } from '../../../globalFunctions';

// Adicione mais sons de "parabéns" aqui quando quiser
let sounds = [successSound, correct, TADAM, duolingo, palmas];
const fetchParabens = async () => {
    const user = getSessionCredentials();

    if (user) {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${user.token}`,
                Accept: 'application/json'
            }
        };
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/parabens`,
                requestConfig
            );
            sounds = data.map(som => som.som);
            console.log(sounds);
        } catch (error) {
            console.error('Erro ao buscar parabéns:', error);
        }
    }
};

fetchParabens();
// Array embaralhado e índice atual
let shuffledSounds: string[] = [];
let currentIndex = 0;

function shuffle(array: string[]) {
    return array
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
}

export function ParabensAleatorio() {
    if (shuffledSounds.length === 0 || currentIndex >= shuffledSounds.length) {
        shuffledSounds = shuffle(sounds);
        currentIndex = 0;
    }

    const audio = new Audio(shuffledSounds[currentIndex]);
    audio.play();

    currentIndex++;
}
